import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import {
    Box,
    Button,
    Container,
    Divider,
    Paper,
    Typography,
} from "@mui/material";
import { useLocation, useNavigate } from 'react-router-dom';
import PlayStoreIcons from '../assets/images/PlayStoreIcons.png';




const ThankYouPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { userName, password, isWhatsappJoinPage, isCounsellingPage } = location.state || {};

    const handleJoinWhatsapp = () => {
        window.open(
            "https://chat.whatsapp.com/JInafRy5T98CYNpbqxXftR",
            "_blank"
        );
    };
    const handleDownloadApp = () => {
        window.open(
            "https://play.google.com/store/apps/details?id=com.splayndid.medineer&pcampaignid=web_share",
            "_blank"
        );
    };
    const handleRedirectToLearner = () => {
        navigate("/medineer/SignIn");
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: `linear-gradient(
                    135deg,
                    hsl(38 92% 50% / .05) 0%,
                    hsl(0 0% 100%) 50%,
                    hsl(262 83% 58% / .05) 100%
                )`,
                px: 2,
                fontWeight: 700,
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: '3.6rem',
                lineHeight: '4rem',
                // color: '#0f1a24'
            }}
        >
            <Container maxWidth="sm">
                <Paper
                    elevation={0}
                    sx={{
                        p: { xs: 4, md: 6 },
                        borderRadius: 5,
                        textAlign: "center",
                        background: "#fff",
                        boxShadow: "0 20px 60px rgba(0,0,0,.08)",
                    }}
                >
                    <CheckCircleIcon
                        sx={{
                            fontSize: 90,
                            color: "#22c55e",
                            mb: 2,
                        }}
                    />

                    <Typography
                        variant="h4"
                        fontWeight={700}
                        gutterBottom
                    >
                        Subscription Successful! 🎉
                    </Typography>
                    {
                        isWhatsappJoinPage === true ?
                            <>
                                <Typography sx={{
                                    mb: 1,
                                    fontSize: '1.4rem',
                                    fontWeight: 700,
                                    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                }}>
                                    Thank You!
                                </Typography>
                                <Button
                                    fullWidth
                                    startIcon={<WhatsAppIcon />}
                                    onClick={handleJoinWhatsapp}
                                    sx={{
                                        // mb: 1,
                                        // py: 1.5,
                                        borderRadius: 3,
                                        fontSize: '1.4rem',
                                        backgroundColor: "#25D366",
                                        color: "#fff",
                                        fontWeight: 600,
                                        textTransform: "none",

                                        "&:hover": {
                                            backgroundColor: "#1ebe5d",
                                        },
                                    }}
                                >
                                    Join WhatsApp Community
                                </Button>
                            </>
                            :
                            <>

                                <Typography
                                    color="text.secondary"
                                    sx={{
                                        mb: 1,
                                        color: '#000',
                                        lineHeight: 1.8,
                                        fontSize: '1.4rem',
                                        fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                    }}
                                >
                                    Thank you for subscribing to {" "}

                                    <a
                                        href="https://medineer.ai"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#04529f", textDecoration: "none", fontWeight: 700 }}
                                    >
                                        Medineer.AI
                                    </a>
                                </Typography>
                                {
                                    isCounsellingPage === true && (
                                        <Typography
                                            color="text.secondary"
                                            sx={{
                                                mb: 1,
                                                color: '#000',
                                                lineHeight: 1.8,
                                                fontSize: '1.4rem',
                                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                            }}
                                        >
                                            Our team will reach out shortly to start your counselling session.
                                        </Typography>
                                    )
                                }

                                {userName && password && (<Typography
                                    color="text.secondary"
                                    sx={{
                                        fontSize: '1.5rem',
                                        textAlign: 'center',
                                        mb: 2,
                                        fontWeight: 600,
                                        fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                    }}
                                >
                                    Your login details have been sent to your email.
                                </Typography>)}
                                {
                                    userName && password &&
                                    <Typography fontWeight={600} mb={2}
                                        sx={{
                                            fontSize: '1.2rem',
                                            textAlign: 'left',
                                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                        }}>
                                        Login Details (for reference):
                                        <ul>
                                            <li>Username: {userName}</li>
                                            <li>Password: {password}</li>
                                        </ul>
                                    </Typography>
                                }

                                <Box
                                    sx={{
                                        // bgcolor: "#f8fafc",
                                        borderRadius: 3,
                                        // p: 3,
                                        mb: 4,
                                        textAlign: "left",

                                    }}
                                >
                                    <Typography fontWeight={600} mb={2}
                                        sx={{
                                            fontSize: '1.8rem',
                                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                        }}>
                                        What's Next
                                    </Typography>
                                    <Divider sx={{ my: 1, borderColor: '#002147' }} />

                                    <Typography sx={{
                                        mb: 1,
                                        fontSize: '1.4rem',
                                        fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                    }}>
                                        ✅ Download the app → Log in with your username & password.
                                    </Typography>
                                    <Typography sx={{
                                        mb: 1,
                                        fontSize: '1.4rem',
                                        fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                    }}>
                                        {/* ✅ Start exploring your deserving college! */}
                                        ✅ Click {" "}
                                        <a
                                            href="https://medineer.ai/medineer/SignIn"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "#04529f", textDecoration: "underline" }}
                                        >
                                            Sign In
                                        </a> {" "}
                                        and start your test practice.
                                    </Typography>

                                    <Typography sx={{
                                        mb: 1,
                                        fontSize: '1.4rem',
                                        fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                    }}>
                                        {/* ✅ Get personalized college suggestions */}
                                        ✅ Use your login details to access Test Series & begin practicing now.
                                    </Typography>

                                    {/* <Typography sx={{
                                        mb: 1,
                                        fontSize: '1.4rem',
                                        fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                    }}>
                                        ✅ Prepare your preference list with AI recommendations
                                    </Typography> */}

                                </Box>
                                {/* {
                                    userName && password && (
                                        <Button
                                            fullWidth
                                            startIcon={<WhatsAppIcon />}
                                            onClick={handleJoinWhatsapp}
                                            sx={{
                                                // mb: 1,
                                                // py: 1.5,
                                                borderRadius: 3,
                                                fontSize: '1.4rem',
                                                backgroundColor: "#25D366",
                                                color: "#fff",
                                                fontWeight: 600,
                                                textTransform: "none",

                                                "&:hover": {
                                                    backgroundColor: "#1ebe5d",
                                                },
                                            }}
                                        >
                                            Join WhatsApp Community
                                        </Button>
                                    )
                                }

                                <Button
                                    fullWidth
                                    startIcon={
                                        // <SchoolIcon />
                                        <img
                                            src={exploreCollege}
                                            alt="Play Store"
                                            style={{
                                                width: 26,
                                                height: 26,
                                                objectFit: "contain",
                                            }}
                                        />
                                    }
                                    // variant="outlined"
                                    sx={{
                                        mt: 2,
                                        borderRadius: 3,
                                        textTransform: "none",
                                        fontWeight: 600,
                                        fontSize: '1.4rem',
                                        // background: 'linear-gradient(135deg, hsl(45 100% 60%), hsl(18 90% 58%))',
                                        backgroundColor: "#FF7A00",
                                        color: '#fff',
                                        // float: 'left'
                                        "&:hover": {
                                            backgroundColor: "#FF7A00",
                                        },
                                    }}
                                    onClick={() => handleRedirectToLearner()}
                                >
                                    Explore Your Deserving College
                                </Button> */}
                                <Button
                                    fullWidth
                                    // startIcon={<WhatsAppIcon />}
                                    startIcon={

                                        <img
                                            src={PlayStoreIcons}
                                            alt="Play Store"
                                            style={{
                                                width: 26,
                                                height: 26,
                                                objectFit: "contain",
                                            }}
                                        />
                                    }
                                    onClick={handleDownloadApp}
                                    sx={{
                                        mt: 2,
                                        // py: 1.5,
                                        borderRadius: 3,
                                        fontSize: '1.4rem',
                                        backgroundColor: "#00264d",
                                        color: "#fff",
                                        fontWeight: 600,
                                        textTransform: "none",

                                        "&:hover": {
                                            backgroundColor: "#00264d",
                                        },
                                    }}
                                >
                                    Download App from Play Store
                                </Button>
                            </>
                    }
                </Paper>
            </Container>
        </Box>
    );
};

export default ThankYouPage;